<template>
  <transition v-if="show" name="fade">
    <tr :class="{ 'opacity-03 disabled': pending }">
      <td :title="'Edit in Details Page'" class="image-cell">
        <router-link :to="getEditDraftRouteConfig()">
          <div v-if="product.image">
            <img style="width: 60px; height: 75px" :src="product.image" />
          </div>
          <div v-else-if="this.shopifyConnected">
            <img
              style="width: 60px; height: 75px"
              class="object-fit-contain"
              src="@/assets/img/icons/icon-upload-image-coming-soon.jpg"
            />
          </div>
          <div v-else>
            <img src="@/assets/img/icons/add_now.png" alt="" />
            <img
              style="width: 60px; height: 75px"
              class="object-fit-contain"
              src="@/assets/img/icons/icon-upload-image.svg"
            />
          </div>
        </router-link>
      </td>
      <td>
        <!--      <span v-if="errors.first('title')">/\</span>-->
        <input
          v-model="product.title"
          v-validate="'required'"
          type="text"
          name="title"
          :title="errors.first('title') && errors.first('title')"
          class="width-120px"
          :class="{ 'input-error': errors.first('title') }"
        />
      </td>
      <td>
        <dropdown-categories
          v-if="categories"
          :is-multi-select="true"
          :is-table-view="true"
          :class="{ invalid: errors.has('product category') }"
          :name="'product category'"
          :searchable="true"
          :on-select="selectProductType"
          :sub-array-name="'view_components'"
          :is-required="false"
          :dropdown-items="categories"
          class="dropdown-wrapper--regular width-120px clearfix"
          input-class="font-serif font-size-18"
        />
      </td>
      <td>
        <input
          v-model="product.leadTime"
          v-validate="'required'"
          type="number"
          name="lead-time"
          class="width-75px"
          :class="{ 'input-error': errors.first('lead-time') }"
        />
      </td>
      <td>
        <input
          v-model="product.msrp"
          v-validate="'required'"
          type="number"
          name="msrp"
          class="width-75px"
          :class="{ 'input-error': errors.first('msrp') }"
        />
      </td>
      <td>
        <input
          v-model="product.wsp"
          v-validate="'required'"
          type="number"
          name="wsp"
          class="width-75px"
          :class="{ 'input-error': errors.first('wsp') }"
        />
      </td>
      <td class="text-center">
        <span v-if="product.validVariant">
          <input type="checkbox" disabled checked />
        </span>
        <router-link
          v-else
          tag="span"
          class="pointer"
          :to="{ name: 'dashboardDraftEdit', params: { productId: product.id } }"
          @click="handleAddVariantClick"
        >
          <img src="@/assets/img/icons/add_now.png" alt="" />
          &nbsp;
          <span class="subheading-2 color-red">ADD NOW</span>
        </router-link>
      </td>
      <td>
        <div style="width: 79px">
          <bulletin-button size="xsm" :disabled="isInvalid" @click="handleAddDraft"> Add </bulletin-button>
          <VPopover offset="16" class="inline-block">
            <span class="pointer pl-5">...</span>
            <template slot="popover">
              <router-link :to="getEditDraftRouteConfig()" class="underline-hover"> Edit in Detail Page </router-link>
              <span class="mx-5">•</span>
              <span class="pointer underline-hover" @click="handleDeleteClick">Delete</span>
            </template>
          </VPopover>
        </div>
      </td>
    </tr>
  </transition>
</template>
<script>
import Vue from "vue";
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import DraftApi from "@/services/api/draftApi";
import ProductApi from "@/services/api/productApi";
import { mapGetters } from "vuex";

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("VPopover", VPopover);

const DraftApiService = new DraftApi(),
  ProductApiService = new ProductApi();
export default {
  name: "DraftProduct",
  props: ["data", "productTypes", "i", "shopifyConnected"],

  data() {
    return {
      product: this.data,
      pending: false,
      show: true,
      invalid: false,
      userEditedProduct: false,
      categories: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
    isInvalid: function () {
      if (!this.product.image) {
        this.invalid = true;
        return true;
      }
      if (!this.product.validVariant) {
        this.invalid = true;
        return true;
      }
      for (let i = 0; i < this.errors.items.length; i++) {
        // eslint-disable-next-line no-underscore-dangle
        if (this.errors.items[i].vmId === this._uid) {
          this.invalid = true;
          return true;
        }
      }

      if (!this.product.categories || !this.product.categories.length) {
        this.invalid = true;
        return true;
      }

      this.invalid = false;
      return false;
    },
  },
  watch: {
    productTypes: function () {
      this.$validator.validate();
    },
    isInvalid: function (result) {
      this.$emit("is-valid", this.product.id, !result);
    },
    product: {
      handler() {
        this.userEditedProduct = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.$validator.validate();
    this.$emit("is-valid", this.product.id, true);
    this.selectActiveCategories();
  },
  methods: {
    selectActiveCategories: function () {
      const cats = JSON.parse(this.productTypes),
        ids = this.product.categories.map((cat) => cat.entity_id);
      this.categories = cats.map((parent) => {
        parent.view_components.map((child) => ({
          ...child,
          ...(ids.includes(child.entity_id) && (child.selected = true)),
        }));
        return parent;
      });
    },
    handleAddVariantClick: function () {
      this.product.validVariant = true;
    },
    handleAddDraft: async function () {
      const { value: success } = await this.$swal({
        title: "Attention",
        text: "Are you sure you want to add this product",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      });
      if (success) {
        this.show = false;
        try {
          await DraftApiService.addDraftProduct(
            {
              lead_time: this.product.leadTime,
              category_ids: this.getCategoryIds(),
              title: this.product.title,
              price: this.product.msrp,
              wholesale_price: this.product.wsp,
            },
            this.product.id
          );
          await this.$swal({
            title: "Success",
            text: "Product Added!",
          });
          this.$store.dispatch("getDraftCount");
          await this.$emit("add-product");
        } catch (error) {
          this.$swal("Alert", "Something went wrong. Please try again later");
        } finally {
          this.show = false;
        }
      }
    },
    getCategoryIds: function () {
      return this.product.categories.map((item) => {
        return item.entity_id;
      });
    },
    handleDeleteClick: async function () {
      const { value: success } = await this.$swal({
        title: "Attention",
        text: "Are you sure you want to delete this draft post",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      });
      if (success) {
        this.pending = true;
        await ProductApiService.removeProduct(this.product.id);
        this.$emit("remove-product", this.product.id);
        this.$store.dispatch("getDraftCount");
        this.show = false;
      }
    },
    selectProductType: function (productType) {
      if (this.product.categories.find((item) => item.entity_id === productType.entity_id)) {
        this.product.categories = this.product.categories.filter((item) => item.entity_id !== productType.entity_id);
      } else {
        this.product.categories.push(productType);
      }
    },
    getEditDraftRouteConfig: function () {
      let query = undefined;
      if (this.user?.role === "ADMIN" || this.user?.role === "PRODUCT_BUILDER") {
        query = this.$route.query;
      }
      return { name: "dashboardDraftEdit", params: { productId: this.product.id }, query };
    },
  },
};
</script>

<style type="scss" scoped>
tr {
  text-align: center;
}
input,
select {
  border-radius: 4px !important;
  padding: 8px 6px;
}
.color-red {
  color: #b50000;
}

.image-cell {
  cursor: pointer;
}
</style>
